// extracted by mini-css-extract-plugin
export default {"Emojify":"bbi_a bhi_g"};